export const collabTypesOptions = [
    {
        id: "",
        name_es: "Tipo de colaboración",
        label: "Collaboration type",
        label_es: "Tipo de colaboración",
        label_en: "Collaboration type",
        checked: false
    },
    {
        id: "science",
        name_es: "Colaboraciones Científicas",
        label: "Scientific",
        label_es: "Científicas",
        label_en: "Scientific",
        checked: true
    },
    {
        id: "innovation",
        name_es: "Colaboraciones de Innovación",
        label: "Innovation",
        label_es: "Innovación",
        label_en: "Innovation",
        checked: false
    }
]

export const collabAreasAllChecked = [
    {
        id: "",
        name_es: "Tipo de Colaboración",
        label: "Collaboration type",
        label_es: "Tipo de Colaboración",
        label_en: "Collaboration type",
        checked: true
    },
    {
        id: "science",
        name_es: "Colaboraciones Científicas",
        label: "Scientific",
        label_es: "Científicas",
        label_en: "Scientific",
        checked: true
    },
    {
        id: "innovation",
        name_es: "Colaboraciones de Innovación",
        label: "Innovation",
        label_es: "Innovación",
        label_en: "Innovation",
        checked: true
    }
]
